<template>
<div>
    <div class="p-editor-container" ref="editor">
        <div ref="toolbarElement" class="p-editor-toolbar">
            <slot name="toolbar">
                <span class="ql-formats">
                    <select class="ql-header" defaultValue="0">
                        <option value="1">Heading</option>
                        <option value="2">Subheading</option>
                        <option value="0">Normal</option>
                    </select>

                    <select class="ql-font">
                        <option></option>
                        <option value="serif"></option>
                        <option value="monospace"></option>
                    </select>

                    <select class="ql-size">
                      <option selected="selected">Padrão</option>
                      <option value="9px">9</option>
                      <option value="10px">10</option>
                      <option value="11px">11</option>
                      <option value="12px">12</option>
                      <option value="13px">13</option>
                      <option value="14px">14</option>
                      <option value="15px">15</option>
                      <option value="16px">16</option>
                      <option value="17px">17</option>
                      <option value="18px">18</option>
                      <option value="24px">24</option>
                      <option value="32px">32</option>
                    </select>
                </span>

                <span class="ql-formats">
                    <button class="ql-bold"></button>
                    <button class="ql-italic"></button>
                    <button class="ql-underline"></button>
                </span>
                <span class="ql-formats">
                    <select class="ql-color"></select>
                    <select class="ql-background"></select>
                </span>
                <span class="ql-formats">
                    <button class="ql-list" value="ordered"></button>
                    <button class="ql-list" value="bullet"></button>
                    <select class="ql-align">
                        <option defaultValue></option>
                        <option value="center"></option>
                        <option value="right"></option>
                        <option value="justify"></option>
                    </select>
                </span>
                <span class="ql-formats">
                    <button class="ql-link"></button>
                    <button class="ql-image"></button>
                    <button class="ql-code-block"></button>
                </span>
                <span class="ql-formats">
                    <button class="ql-clean"></button>
                </span>
                <span class="ql-formats">
                    <button id="insert-table" class="small" @click="selectInfoTable()" title="Inserir tabela">
                      <i class="fa-solid fa-table"></i>
                    </button>
                    <speech-rec-editor></speech-rec-editor>
                    <span>
                      <button id="ampliar" class="small" @click="$emit('fullscreen')" title="Ampliação da tela" v-if="fullscreen === true || fullscreen === false">
                          <i class="fas fa-expand" v-if="!fullscreen"></i>
                          <i class="fas fa-compress" v-else></i>
                      </button>

                      <button id="quebrapag" class="small" @click="inserir_quebra_de_pagina()" title="Inserir Quebra de Página">
                        <i class="fa-regular fa-file-dashed-line"></i>
                      </button>
                    </span>
                </span>
            </slot>
        </div>
        <div ref="editorElement" class="p-editor-content" :style="editorStyle"></div>
    </div>

    <!-- Modal da Tabela -->
    <div class="modal fade" :id="tabelaModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Inserir Tabela</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col col-12">
                            <az-input
                                type="button-group" 
                                label="Linhas"
                                :optionsList="[
                                    { id: 1, search: '1' }, 
                                    { id: 2, search: '2' }, 
                                    { id: 3, search: '3' }, 
                                    { id: 4, search: '4' }, 
                                    { id: 5, search: '5' }, 
                                    { id: 6, search: '6' }, 
                                    { id: 7, search: '7' }, 
                                    { id: 8, search: '8' }, 
                                    { id: 9, search: '9' }, 
                                ]"
                                v-model="linhas" />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col col-12">
                            <az-input
                                type="button-group" 
                                label="Colunas"
                                :optionsList="[
                                    { id: 1, search: '1' }, 
                                    { id: 2, search: '2' }, 
                                    { id: 3, search: '3' }, 
                                    { id: 4, search: '4' }, 
                                    { id: 5, search: '5' }, 
                                    { id: 6, search: '6' }, 
                                    { id: 7, search: '7' }, 
                                    { id: 8, search: '8' }, 
                                    { id: 9, search: '9' }, 
                                ]"
                                v-model="colunas" />
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                    <button type="button" class="btn btn-success" @click="insertTable()">Incluir</button>
                </div>
            </div>
        </div>
    </div>

    <!-- Modal Edição Campo -->
    <div class="modal fade" :id="campoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
        <div class="modal-dialog modal-dialog-scrollable modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">
                        Edição de Campo
                        <span class="badge badge-secondary ml-2" v-if="campo_edicao && campo_edicao.id">
                            {{ campo_edicao.id }}
                        </span>
                    </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div v-if="campo_edicao" @keydown.enter.prevent="proximo()">
                        <az-input 
                            v-if="false"
                            ref="campo_edicao_input"
                            :label="campo_edicao.label"
                            v-model="campo_edicao.value"
                            @onEnter="proximo()" />

                        <campos-formulario-2
                            v-if="campo_edicao_lista"
                            v-model="campo_edicao_lista" />

                        <div class="alert alert-info mt-3" v-if="texto_em_volta">
                            {{ texto_em_volta.antes }}
                            <strong style="background-color: yellow;">{{ campo_edicao.value ? campo_edicao.value : 'Não Informado' }}</strong>
                            {{ texto_em_volta.depois }}
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    <button type="button" class="btn btn-outline-success" @click="anterior()">Anterior</button>
                    <button type="button" class="btn btn-success" @click="proximo()">Próximo</button>
                </div>
            </div>
        </div>
    </div>

</div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import * as Quill from "quill";
import QuillBetterTable from 'quill-better-table';
import AzInput from './AzInput.vue';
import SpeechRecEditor from '../speech/SpeechRecEditor.vue';
// import 'quill/dist/quill.snow.css';

// quill: null,

export default {
    name: 'AzEditor',

    data() { 
        return { 
            quill: null, 
            tabelaModal: "tabelaModal",
            campoModal: "campoModal",
            linhas: 3,
            colunas: 3, 
            campo_base: null, 
            campo_edicao: null, 
            lista_campos: null, 
            campo_edicao_lista: null, 
            last_sel: null, 
            texto_em_volta: "", 
        }
    },

    components: { 
        AzInput,
        SpeechRecEditor, 
    },

    props: {
        value: String,
        placeholder: String,
        readonly: Boolean,
        formats: Array,
        editorStyle: null,
        textos: Array,
        fullscreen: null, 
        form_campos: null, 
    },

    watch: {
        value(newValue, oldValue) {
            if (newValue !== oldValue && this.quill && !this.quill.hasFocus()) {
                this.renderValue(newValue);
            }
        }, 
    },

    mounted() {
        let uuid = this.uuidv4();
        this.tabelaModal = 'tabelaModal' + uuid;
        this.campoModal = 'campoModal' + uuid;

        const printableKeys = [
            ...Array.from({ length: 26 }, (_, i) => 65 + i), // A–Z
            ...Array.from({ length: 10 }, (_, i) => 48 + i), // 0–9
            32, // espaço
            188, // vírgula
            190, // ponto
            222, // aspas
        ];

        let bindings = { ...QuillBetterTable.keyboardBindings };

        if ( 1==1 || ( window.redir == 'teste' ) ) { 

            bindings.shifttab = { 
                key: 9, // tecla Tab com shift
                shiftKey: true,
                handler: this.key_tab_handler
            };

            bindings.tab = {
                key: 9, // tecla Tab
                handler: this.key_tab_handler
            };

            bindings.blockEdit = {
                key: printableKeys, // lista geral de caracteres
                handler: this.key_geral_handler
            };

        }

        this.quill = new Quill(this.$refs.editorElement, {
            modules: {
                toolbar: this.$refs.toolbarElement,
                table: false,
                'better-table': {
                    operationMenu: {
                        items: {
                            insertColumnRight: { text: 'Inserir coluna depois'},
                            insertColumnLeft: { text: 'Inserir coluna antes'},
                            insertRowUp: { text: 'Inserir linha antes'},
                            insertRowDown: { text: 'Inserir linha depois'},
                            mergeCells: { text: 'Mesclar células'},
                            unmergeCells: { text: 'Separar células' },
                            deleteColumn: { text: 'Apagar coluna'},
                            deleteRow: { text: 'Apagar linha'},
                            deleteTable: { text: 'Apagar tabela'}
                        }
                    }
                },
                keyboard: {
                    bindings: bindings, 
                }
            },
            readOnly: this.readOnly,
            theme: 'snow',
            formats: this.formats
        });

        this.quill.on('selection-change', (range) => {
            if (range) { 
                this.$emit('quillativo', this); 
            }
        });

        this.quill.on('text-change', (delta, source) => {
            let html = this.$refs.editorElement.children[0].innerHTML;
            if (html === '<p><br></p>') {
                html = '';
            }

            this.$emit('input', html);
            this.$emit('text-change', {
                htmlValue: html,
                textValue: this.quill.getText(),
                delta: delta,
                source: source
            });
        });

        this.renderValue(this.value);

        //

        if ( window.redir == 'celulamater' ) { 

            this.quill.clipboard.addMatcher(Node.TEXT_NODE, function(node, delta) {
                console.log(node, delta);

                const lines = node.data.split('\n');
                const ops = [];

                lines.forEach((line, i) => {
                    if (line.length > 0) {
                        ops.push({ insert: line });
                    }
                    // Adiciona quebra de linha entre as linhas
                    if (i !== lines.length - 1) {
                        ops.push({ insert: '\n' });
                    }
                });

                delta.ops = ops;
            
                return delta;
            });

        }
        
        //

        if ( this.readonly ) { 
            this.quill.enable(false);
        }
    },

    methods: {
        insert_text_on_quill(html) { 
            const range = this.quill.getSelection(true) // true = força foco

            if (!range) return

            // Converte o HTML para Delta e insere na posição do cursor
            this.quill.clipboard.dangerouslyPasteHTML(range.index, html, 'user')

            // Move o cursor para depois do conteúdo inserido
            const length = this.quill.getLength()
            this.quill.setSelection(range.index + this.quill.getLength() - length, 0)
        },

        anterior () { 
            this.key_tab_handler(this.last_sel, { event: { shiftKey: true } });
            this.key_geral_handler(null, null);

            this.last_sel = this.quill.getSelection(true);
        },

        proximo () { 
            this.key_tab_handler(this.last_sel, null);
            this.key_geral_handler(null, null);

            this.last_sel = this.quill.getSelection(true);
        },

        get_campos_texto (texto) { 
            if ( !texto ) { 
                return [];
            }

            let matches = [];

            let temp = document.createElement('div'); // Create a temporary element
            temp.innerHTML = texto; // Set the passed string as HTML to the temporary element
            let campos = temp.getElementsByClassName('ql-campo'); // Find an element with the passed id

            _.each(campos, item => {
                matches.push(item.id);
            });

            return matches;
        },

        find_campo(lista, id, nivel = 0) { 
            
            if ( nivel > 10 ) { 
                return null;
            }

            let campo_edit; 

            lista.forEach(item => {
                if ( item.type == 'group' && item.campos && item.campos.length ) { 
                    let campo_search = this.find_campo(item.campos, id, nivel + 1);

                    if ( campo_search ) { 
                        campo_edit = campo_search;
                    }
                } else { 
                    if ( item.id === id ) { 
                        campo_edit = item;
                    }
                }
            });

            return campo_edit;

            /*
            let campo_edit = this.form_campos.flatMap(item => ( item.type == 'group' && item.campos && item.campos.length ) ? item.campos : [item])
                    .find(item => item.id === campo_id ); 
            */

        },

        key_handler_geral (range, context) { 
            console.log('key', range, context);
        },

        key_geral_handler (range, context) { 
            const campos = Array.from(this.quill.root.querySelectorAll('.ql-campo'));
            if (!campos.length) return true;

            const sel = this.quill.getSelection(true);
            if (!sel) return false;

            // Encontrar o campo atual
            let currentIndex = -1;
            let campo_id;
            
            this.texto_em_volta = ""; 

            console.log('ghs', sel);
            console.log('ghc', campos);
            
            for (let i = 0; i < campos.length; i++) {
                const campo = campos[i];
                const campoIndex = this.quill.getIndex(Quill.find(campo));

                if ( ( sel.index >= campoIndex ) && ( sel.index <= ( campoIndex + campo.innerText.length ) ) ) {
                    currentIndex = i;
                    campo_id = campo.id;

                    let antes = campoIndex > 500 ? 500 : campoIndex;

                    this.texto_em_volta = { 
                        antes: this.quill.getText( campoIndex - antes, antes ), 
                        depois: this.quill.getText( campoIndex + campo.innerText.length, 500 )
                    };

                    break;
                }
            }

            if ( currentIndex >= 0 ) {

                let campo_edit = this.find_campo(this.form_campos, campo_id);

                if ( !campo_edit ) { 
                    this.$toast.add({ 
                        severity: 'error', 
                        summary: 'Atenção', 
                        detail: 'Campo não encontrado: ' + campo_id, 
                        life: 3000
                    });
                    
                    console.log('Campo não encontrado:', campo_id);
                    console.log('Campos:', this.form_campos);
                }

                /*
                let campo_edit = this.form_campos.flatMap(item => ( item.type == 'group' && item.campos && item.campos.length ) ? item.campos : [item])
                    .find(item => item.id === campo_id ); 
                */
                
                if ( campo_edit ) {

                    if ( context && context.event && ( context.event.key === " " || context.event.key === "Enter" ) ) { 

                        let endIndex = sel.index + ( campos[currentIndex].innerText.length - ( sel.index - this.quill.getIndex(Quill.find(campos[currentIndex])) ) );

                        this.quill.insertText(endIndex, ' ', 'user');
                        this.quill.removeFormat(endIndex, 1, 'user');

                        this.quill.setSelection(endIndex + 1, 0, 'silent');

                        return false; 

                    }

                    this.campo_edicao = campo_edit;
                    this.campo_base = campo_edit;
                    this.campo_edicao_lista = [ campo_edit ];

                    this.lista_campos = this.get_campos_texto(this.value);

                    if ( range === null && context === null ) { 
                        //
                    } else { 
                        this.last_sel = null; 
                        $('#'+this.campoModal).modal('show');
                    }

                    setTimeout(() => {

                        // localizar o input ou select dentro do modal e dar o foco nele usando jquery.
                        let input = $('#'+this.campoModal).find('input, select, textarea').first();

                        if ( input.length ) { 
                            input.focus();
                        }

                    }, 500);
                        
                }
                
                return false; // impede o Quill de processar a tecla
            }

            return true; // permite digitação normal
        },

        key_tab_handler (range,context) {
            // AQUI ENTRA SUA LÓGICA DE NAVEGAÇÃO ENTRE CAMPOS
            const campos = Array.from(this.quill.root.querySelectorAll('.ql-campo'));
            if (!campos.length) { 
                this.quill.insertText(range.index, '\t');
                this.quill.setSelection(range.index + 1);

                return false; 
            }

            const sel = range ? range : this.quill.getSelection(true);
            if (!sel) return false;

            console.log('range', range);
            console.log('context', context);
            console.log('campos', campos);
            console.log('sel', sel);

            // Encontrar o campo atual
            let currentIndex = -1;
            let tamanho = 0; 
            for (let i = 0; i < campos.length; i++) {
                const campo = campos[i];
                const campoIndex = this.quill.getIndex(Quill.find(campo));

                if (sel.index >= campoIndex && sel.index <= campoIndex + campo.innerText.length) {
                    currentIndex = i;
                    break;
                }
            }

            // Mover para o próximo campo
            if (currentIndex >= 0) {

                let nextIndex;

                if (context && context.event && context.event.shiftKey) {
                    nextIndex = (currentIndex - 1) < 0 ? campos.length - 1 : currentIndex - 1;

                    if ( !currentIndex ) { 
                        $('#' + this.campoModal).modal('hide');
                        return false; 
                    }
                } else { 
                    nextIndex = (currentIndex + 1) % campos.length;

                    if ( !nextIndex ) { 
                        $('#' + this.campoModal).modal('hide');
                        return false; 
                    }
                }
                
                const nextCampo = campos[nextIndex];
                const nextCampoIndex = this.quill.getIndex(Quill.find(nextCampo));

                tamanho = nextCampo ? nextCampo.innerText.length : 0;

                this.quill.setSelection(nextCampoIndex, tamanho, 'user');

                return false; 

            } else {

                for (let i = 0; i < campos.length; i++) {
                    const campo = campos[i];
                    const campoIndex = this.quill.getIndex(Quill.find(campo));

                    if (sel.index < campoIndex ) {
                        currentIndex = i;
                        break;
                    }
                }

                if ( currentIndex >= 0 ) { 
                    const nextCampo = campos[currentIndex];
                    const nextCampoIndex = this.quill.getIndex(Quill.find(nextCampo));

                    tamanho = nextCampo ? nextCampo.innerText.length : 0;
                    
                    this.quill.setSelection(nextCampoIndex, tamanho, 'user');
                    return false; 
                }

            }

            return false; 
        },
    
        inserir_quebra_de_pagina () { 
            const range = this.quill.getSelection();
            if (range) {
                this.quill.insertText(range.index, '#novapagina# \n\n', 'user');
                this.quill.setSelection(range.index + 15, 0, 'silent');
            }
        },

        teste11 () { 
            this.quill.enable(false);
        },

        teste1() { 
            console.log('Selec', this.quill.getSelection());
        },

        teste2() { 
            // console.log('Bounds', this.quill.getBounds(41));
            this.quill.setSelection(20,10);
        },

        uuidv4() {
            return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
              (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
            );
        },

        selectInfoTable() { 
            $('#'+this.tabelaModal).modal('show');
        },

        insertTable() { 
            let tableModule = this.quill.getModule('better-table')
            
            if ( tableModule ) { 
              tableModule.insertTable(this.linhas, this.colunas);
            }

            $('#'+this.tabelaModal).modal('hide');
        },

        renderValue(value) {
            if (this.quill) {
                if (value) { 
                    // this.quill.clipboard.dangerouslyPasteHTML(value);
                    this.quill.setContents(this.quill.clipboard.convert({ html: value }), 'silent');
                } else { 
                    this.quill.setText('');
                }
            }
        }
    }
    ,
    beforeDestroy() {
        this.quill = null;
    }

}
</script>

<style>
/*!
 * Quill Editor v1.3.3
 * https://quilljs.com/
 * Copyright (c) 2014, Jason Chen
 * Copyright (c) 2013, salesforce.com
 */
.ql-container {
  box-sizing: border-box;
  font-family: Helvetica, Arial, sans-serif;
  font-size: 13px;
  height: 100%;
  margin: 0px;
  position: relative;
}
.ql-container.ql-disabled .ql-tooltip {
  visibility: hidden;
}
.ql-container.ql-disabled .ql-editor ul[data-checked] > li::before {
  pointer-events: none;
}
.ql-clipboard {
  left: -100000px;
  height: 1px;
  overflow-y: hidden;
  position: absolute;
  top: 50%;
}
.ql-clipboard p {
  margin: 0;
  padding: 0;
}
.ql-editor {
  box-sizing: border-box;
  line-height: 1.42;
  height: 100%;
  outline: none;
  overflow-y: auto;
  padding: 12px 15px;
  tab-size: 4;
  -moz-tab-size: 4;
  text-align: left;
  white-space: pre-wrap;
  word-wrap: break-word;
}
.ql-editor > * {
  cursor: text;
}
.ql-editor p,
.ql-editor ol,
.ql-editor ul,
.ql-editor pre,
.ql-editor blockquote,
.ql-editor h1,
.ql-editor h2,
.ql-editor h3,
.ql-editor h4,
.ql-editor h5,
.ql-editor h6 {
  margin: 0;
  padding: 0;
  counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
}
.ql-editor ol,
.ql-editor ul {
  padding-left: 1.5em;
}
.ql-editor ol > li,
.ql-editor ul > li {
  list-style-type: none;
}
.ql-editor ul > li::before {
  content: '\2022';
}
.ql-editor ul[data-checked=true],
.ql-editor ul[data-checked=false] {
  pointer-events: none;
}
.ql-editor ul[data-checked=true] > li *,
.ql-editor ul[data-checked=false] > li * {
  pointer-events: all;
}
.ql-editor ul[data-checked=true] > li::before,
.ql-editor ul[data-checked=false] > li::before {
  color: #777;
  cursor: pointer;
  pointer-events: all;
}
.ql-editor ul[data-checked=true] > li::before {
  content: '\2611';
}
.ql-editor ul[data-checked=false] > li::before {
  content: '\2610';
}
.ql-editor li::before {
  display: inline-block;
  white-space: nowrap;
  width: 1.2em;
}
.ql-editor li:not(.ql-direction-rtl)::before {
  margin-left: -1.5em;
  margin-right: 0.3em;
  text-align: right;
}
.ql-editor li.ql-direction-rtl::before {
  margin-left: 0.3em;
  margin-right: -1.5em;
}
.ql-editor ol li:not(.ql-direction-rtl),
.ql-editor ul li:not(.ql-direction-rtl) {
  padding-left: 1.5em;
}
.ql-editor ol li.ql-direction-rtl,
.ql-editor ul li.ql-direction-rtl {
  padding-right: 1.5em;
}
.ql-editor ol li {
  counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
  counter-increment: list-0;
}
.ql-editor ol li:before {
  content: counter(list-0, decimal) '. ';
}
.ql-editor ol li.ql-indent-1 {
  counter-increment: list-1;
}
.ql-editor ol li.ql-indent-1:before {
  content: counter(list-1, lower-alpha) '. ';
}
.ql-editor ol li.ql-indent-1 {
  counter-reset: list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
}
.ql-editor ol li.ql-indent-2 {
  counter-increment: list-2;
}
.ql-editor ol li.ql-indent-2:before {
  content: counter(list-2, lower-roman) '. ';
}
.ql-editor ol li.ql-indent-2 {
  counter-reset: list-3 list-4 list-5 list-6 list-7 list-8 list-9;
}
.ql-editor ol li.ql-indent-3 {
  counter-increment: list-3;
}
.ql-editor ol li.ql-indent-3:before {
  content: counter(list-3, decimal) '. ';
}
.ql-editor ol li.ql-indent-3 {
  counter-reset: list-4 list-5 list-6 list-7 list-8 list-9;
}
.ql-editor ol li.ql-indent-4 {
  counter-increment: list-4;
}
.ql-editor ol li.ql-indent-4:before {
  content: counter(list-4, lower-alpha) '. ';
}
.ql-editor ol li.ql-indent-4 {
  counter-reset: list-5 list-6 list-7 list-8 list-9;
}
.ql-editor ol li.ql-indent-5 {
  counter-increment: list-5;
}
.ql-editor ol li.ql-indent-5:before {
  content: counter(list-5, lower-roman) '. ';
}
.ql-editor ol li.ql-indent-5 {
  counter-reset: list-6 list-7 list-8 list-9;
}
.ql-editor ol li.ql-indent-6 {
  counter-increment: list-6;
}
.ql-editor ol li.ql-indent-6:before {
  content: counter(list-6, decimal) '. ';
}
.ql-editor ol li.ql-indent-6 {
  counter-reset: list-7 list-8 list-9;
}
.ql-editor ol li.ql-indent-7 {
  counter-increment: list-7;
}
.ql-editor ol li.ql-indent-7:before {
  content: counter(list-7, lower-alpha) '. ';
}
.ql-editor ol li.ql-indent-7 {
  counter-reset: list-8 list-9;
}
.ql-editor ol li.ql-indent-8 {
  counter-increment: list-8;
}
.ql-editor ol li.ql-indent-8:before {
  content: counter(list-8, lower-roman) '. ';
}
.ql-editor ol li.ql-indent-8 {
  counter-reset: list-9;
}
.ql-editor ol li.ql-indent-9 {
  counter-increment: list-9;
}
.ql-editor ol li.ql-indent-9:before {
  content: counter(list-9, decimal) '. ';
}
.ql-editor .ql-indent-1:not(.ql-direction-rtl) {
  padding-left: 3em;
}
.ql-editor li.ql-indent-1:not(.ql-direction-rtl) {
  padding-left: 4.5em;
}
.ql-editor .ql-indent-1.ql-direction-rtl.ql-align-right {
  padding-right: 3em;
}
.ql-editor li.ql-indent-1.ql-direction-rtl.ql-align-right {
  padding-right: 4.5em;
}
.ql-editor .ql-indent-2:not(.ql-direction-rtl) {
  padding-left: 6em;
}
.ql-editor li.ql-indent-2:not(.ql-direction-rtl) {
  padding-left: 7.5em;
}
.ql-editor .ql-indent-2.ql-direction-rtl.ql-align-right {
  padding-right: 6em;
}
.ql-editor li.ql-indent-2.ql-direction-rtl.ql-align-right {
  padding-right: 7.5em;
}
.ql-editor .ql-indent-3:not(.ql-direction-rtl) {
  padding-left: 9em;
}
.ql-editor li.ql-indent-3:not(.ql-direction-rtl) {
  padding-left: 10.5em;
}
.ql-editor .ql-indent-3.ql-direction-rtl.ql-align-right {
  padding-right: 9em;
}
.ql-editor li.ql-indent-3.ql-direction-rtl.ql-align-right {
  padding-right: 10.5em;
}
.ql-editor .ql-indent-4:not(.ql-direction-rtl) {
  padding-left: 12em;
}
.ql-editor li.ql-indent-4:not(.ql-direction-rtl) {
  padding-left: 13.5em;
}
.ql-editor .ql-indent-4.ql-direction-rtl.ql-align-right {
  padding-right: 12em;
}
.ql-editor li.ql-indent-4.ql-direction-rtl.ql-align-right {
  padding-right: 13.5em;
}
.ql-editor .ql-indent-5:not(.ql-direction-rtl) {
  padding-left: 15em;
}
.ql-editor li.ql-indent-5:not(.ql-direction-rtl) {
  padding-left: 16.5em;
}
.ql-editor .ql-indent-5.ql-direction-rtl.ql-align-right {
  padding-right: 15em;
}
.ql-editor li.ql-indent-5.ql-direction-rtl.ql-align-right {
  padding-right: 16.5em;
}
.ql-editor .ql-indent-6:not(.ql-direction-rtl) {
  padding-left: 18em;
}
.ql-editor li.ql-indent-6:not(.ql-direction-rtl) {
  padding-left: 19.5em;
}
.ql-editor .ql-indent-6.ql-direction-rtl.ql-align-right {
  padding-right: 18em;
}
.ql-editor li.ql-indent-6.ql-direction-rtl.ql-align-right {
  padding-right: 19.5em;
}
.ql-editor .ql-indent-7:not(.ql-direction-rtl) {
  padding-left: 21em;
}
.ql-editor li.ql-indent-7:not(.ql-direction-rtl) {
  padding-left: 22.5em;
}
.ql-editor .ql-indent-7.ql-direction-rtl.ql-align-right {
  padding-right: 21em;
}
.ql-editor li.ql-indent-7.ql-direction-rtl.ql-align-right {
  padding-right: 22.5em;
}
.ql-editor .ql-indent-8:not(.ql-direction-rtl) {
  padding-left: 24em;
}
.ql-editor li.ql-indent-8:not(.ql-direction-rtl) {
  padding-left: 25.5em;
}
.ql-editor .ql-indent-8.ql-direction-rtl.ql-align-right {
  padding-right: 24em;
}
.ql-editor li.ql-indent-8.ql-direction-rtl.ql-align-right {
  padding-right: 25.5em;
}
.ql-editor .ql-indent-9:not(.ql-direction-rtl) {
  padding-left: 27em;
}
.ql-editor li.ql-indent-9:not(.ql-direction-rtl) {
  padding-left: 28.5em;
}
.ql-editor .ql-indent-9.ql-direction-rtl.ql-align-right {
  padding-right: 27em;
}
.ql-editor li.ql-indent-9.ql-direction-rtl.ql-align-right {
  padding-right: 28.5em;
}
.ql-editor .ql-video {
  display: block;
  max-width: 100%;
}
.ql-editor .ql-video.ql-align-center {
  margin: 0 auto;
}
.ql-editor .ql-video.ql-align-right {
  margin: 0 0 0 auto;
}
.ql-editor .ql-bg-black {
  background-color: #000;
}
.ql-editor .ql-bg-red {
  background-color: #e60000;
}
.ql-editor .ql-bg-orange {
  background-color: #f90;
}
.ql-editor .ql-bg-yellow {
  background-color: #ff0;
}
.ql-editor .ql-bg-green {
  background-color: #008a00;
}
.ql-editor .ql-bg-blue {
  background-color: #06c;
}
.ql-editor .ql-bg-purple {
  background-color: #93f;
}
.ql-editor .ql-color-white {
  color: #fff;
}
.ql-editor .ql-color-red {
  color: #e60000;
}
.ql-editor .ql-color-orange {
  color: #f90;
}
.ql-editor .ql-color-yellow {
  color: #ff0;
}
.ql-editor .ql-color-green {
  color: #008a00;
}
.ql-editor .ql-color-blue {
  color: #06c;
}
.ql-editor .ql-color-purple {
  color: #93f;
}
.ql-editor .ql-font-serif {
  font-family: Georgia, Times New Roman, serif;
}
.ql-editor .ql-font-monospace {
  font-family: Monaco, Courier New, monospace;
}
.ql-editor .ql-size-small {
  font-size: 0.75em;
}
.ql-editor .ql-size-large {
  font-size: 1.5em;
}
.ql-editor .ql-size-huge {
  font-size: 2.5em;
}
.ql-editor .ql-direction-rtl {
  direction: rtl;
  text-align: inherit;
}
.ql-editor .ql-align-center {
  text-align: center;
}
.ql-editor .ql-align-justify {
  text-align: justify;
}
.ql-editor .ql-align-right {
  text-align: right;
}
.ql-editor.ql-blank::before {
  color: rgba(0,0,0,0.6);
  content: attr(data-placeholder);
  font-style: italic;
  left: 15px;
  pointer-events: none;
  position: absolute;
  right: 15px;
}
.ql-snow.ql-toolbar:after,
.ql-snow .ql-toolbar:after {
  clear: both;
  content: '';
  display: table;
}
.ql-snow.ql-toolbar button,
.ql-snow .ql-toolbar button {
  background: none;
  border: none;
  cursor: pointer;
  display: inline-block;
  float: left;
  height: 24px;
  padding: 3px 5px;
  width: 28px;
}
.ql-snow.ql-toolbar button svg,
.ql-snow .ql-toolbar button svg {
  float: left;
  height: 100%;
}
.ql-snow.ql-toolbar button:active:hover,
.ql-snow .ql-toolbar button:active:hover {
  outline: none;
}
.ql-snow.ql-toolbar input.ql-image[type=file],
.ql-snow .ql-toolbar input.ql-image[type=file] {
  display: none;
}
.ql-snow.ql-toolbar button:hover,
.ql-snow .ql-toolbar button:hover,
.ql-snow.ql-toolbar button:focus,
.ql-snow .ql-toolbar button:focus,
.ql-snow.ql-toolbar button.ql-active,
.ql-snow .ql-toolbar button.ql-active,
.ql-snow.ql-toolbar .ql-picker-label:hover,
.ql-snow .ql-toolbar .ql-picker-label:hover,
.ql-snow.ql-toolbar .ql-picker-label.ql-active,
.ql-snow .ql-toolbar .ql-picker-label.ql-active,
.ql-snow.ql-toolbar .ql-picker-item:hover,
.ql-snow .ql-toolbar .ql-picker-item:hover,
.ql-snow.ql-toolbar .ql-picker-item.ql-selected,
.ql-snow .ql-toolbar .ql-picker-item.ql-selected {
  color: #06c;
}
.ql-snow.ql-toolbar button:hover .ql-fill,
.ql-snow .ql-toolbar button:hover .ql-fill,
.ql-snow.ql-toolbar button:focus .ql-fill,
.ql-snow .ql-toolbar button:focus .ql-fill,
.ql-snow.ql-toolbar button.ql-active .ql-fill,
.ql-snow .ql-toolbar button.ql-active .ql-fill,
.ql-snow.ql-toolbar .ql-picker-label:hover .ql-fill,
.ql-snow .ql-toolbar .ql-picker-label:hover .ql-fill,
.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-fill,
.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-fill,
.ql-snow.ql-toolbar .ql-picker-item:hover .ql-fill,
.ql-snow .ql-toolbar .ql-picker-item:hover .ql-fill,
.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-fill,
.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-fill,
.ql-snow.ql-toolbar button:hover .ql-stroke.ql-fill,
.ql-snow .ql-toolbar button:hover .ql-stroke.ql-fill,
.ql-snow.ql-toolbar button:focus .ql-stroke.ql-fill,
.ql-snow .ql-toolbar button:focus .ql-stroke.ql-fill,
.ql-snow.ql-toolbar button.ql-active .ql-stroke.ql-fill,
.ql-snow .ql-toolbar button.ql-active .ql-stroke.ql-fill,
.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,
.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,
.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,
.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,
.ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,
.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,
.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill,
.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill {
  fill: #06c;
}
.ql-snow.ql-toolbar button:hover .ql-stroke,
.ql-snow .ql-toolbar button:hover .ql-stroke,
.ql-snow.ql-toolbar button:focus .ql-stroke,
.ql-snow .ql-toolbar button:focus .ql-stroke,
.ql-snow.ql-toolbar button.ql-active .ql-stroke,
.ql-snow .ql-toolbar button.ql-active .ql-stroke,
.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke,
.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke,
.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke,
.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke,
.ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke,
.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke,
.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke,
.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke,
.ql-snow.ql-toolbar button:hover .ql-stroke-miter,
.ql-snow .ql-toolbar button:hover .ql-stroke-miter,
.ql-snow.ql-toolbar button:focus .ql-stroke-miter,
.ql-snow .ql-toolbar button:focus .ql-stroke-miter,
.ql-snow.ql-toolbar button.ql-active .ql-stroke-miter,
.ql-snow .ql-toolbar button.ql-active .ql-stroke-miter,
.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke-miter,
.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke-miter,
.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,
.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,
.ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke-miter,
.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke-miter,
.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter,
.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter {
  stroke: #06c;
}
@media (pointer: coarse) {
  .ql-snow.ql-toolbar button:hover:not(.ql-active),
  .ql-snow .ql-toolbar button:hover:not(.ql-active) {
    color: #444;
  }
  .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-fill,
  .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-fill,
  .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill,
  .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill {
    fill: #444;
  }
  .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke,
  .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke,
  .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter,
  .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter {
    stroke: #444;
  }
}
.ql-snow {
  box-sizing: border-box;
}
.ql-snow * {
  box-sizing: border-box;
}
.ql-snow .ql-hidden {
  display: none;
}
.ql-snow .ql-out-bottom,
.ql-snow .ql-out-top {
  visibility: hidden;
}
.ql-snow .ql-tooltip {
  position: absolute;
  transform: translateY(10px);
}
.ql-snow .ql-tooltip a {
  cursor: pointer;
  text-decoration: none;
}
.ql-snow .ql-tooltip.ql-flip {
  transform: translateY(-10px);
}
.ql-snow .ql-formats {
  display: inline-block;
  vertical-align: middle;
}
.ql-snow .ql-formats:after {
  clear: both;
  content: '';
  display: table;
}
.ql-snow .ql-stroke {
  fill: none;
  stroke: #444;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 2;
}
.ql-snow .ql-stroke-miter {
  fill: none;
  stroke: #444;
  stroke-miterlimit: 10;
  stroke-width: 2;
}
.ql-snow .ql-fill,
.ql-snow .ql-stroke.ql-fill {
  fill: #444;
}
.ql-snow .ql-empty {
  fill: none;
}
.ql-snow .ql-even {
  fill-rule: evenodd;
}
.ql-snow .ql-thin,
.ql-snow .ql-stroke.ql-thin {
  stroke-width: 1;
}
.ql-snow .ql-transparent {
  opacity: 0.4;
}
.ql-snow .ql-direction svg:last-child {
  display: none;
}
.ql-snow .ql-direction.ql-active svg:last-child {
  display: inline;
}
.ql-snow .ql-direction.ql-active svg:first-child {
  display: none;
}
.ql-snow .ql-editor h1 {
  font-size: 2em;
}
.ql-snow .ql-editor h2 {
  font-size: 1.5em;
}
.ql-snow .ql-editor h3 {
  font-size: 1.17em;
}
.ql-snow .ql-editor h4 {
  font-size: 1em;
}
.ql-snow .ql-editor h5 {
  font-size: 0.83em;
}
.ql-snow .ql-editor h6 {
  font-size: 0.67em;
}
.ql-snow .ql-editor a {
  text-decoration: underline;
}
.ql-snow .ql-editor blockquote {
  border-left: 4px solid #ccc;
  margin-bottom: 5px;
  margin-top: 5px;
  padding-left: 16px;
}
.ql-snow .ql-editor code,
.ql-snow .ql-editor pre {
  background-color: #f0f0f0;
  border-radius: 3px;
}
.ql-snow .ql-editor pre {
  white-space: pre-wrap;
  margin-bottom: 5px;
  margin-top: 5px;
  padding: 5px 10px;
}
.ql-snow .ql-editor code {
  font-size: 85%;
  padding: 2px 4px;
}
.ql-snow .ql-editor pre.ql-syntax {
  background-color: #23241f;
  color: #f8f8f2;
  overflow: visible;
}
.ql-snow .ql-editor img {
  max-width: 100%;
}
.ql-snow .ql-picker {
  color: #444;
  display: inline-block;
  float: left;
  font-size: 14px;
  font-weight: 500;
  height: 24px;
  position: relative;
  vertical-align: middle;
}
.ql-snow .ql-picker-label {
  cursor: pointer;
  display: inline-block;
  height: 100%;
  padding-left: 8px;
  padding-right: 2px;
  position: relative;
  width: 100%;
}
.ql-snow .ql-picker-label::before {
  display: inline-block;
  line-height: 22px;
}
.ql-snow .ql-picker-options {
  background-color: #fff;
  display: none;
  min-width: 100%;
  padding: 4px 8px;
  position: absolute;
  white-space: nowrap;
}
.ql-snow .ql-picker-options .ql-picker-item {
  cursor: pointer;
  display: block;
  padding-bottom: 5px;
  padding-top: 5px;
}
.ql-snow .ql-picker.ql-expanded .ql-picker-label {
  color: #ccc;
  z-index: 2;
}
.ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-fill {
  fill: #ccc;
}
.ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-stroke {
  stroke: #ccc;
}
.ql-snow .ql-picker.ql-expanded .ql-picker-options {
  display: block;
  margin-top: -1px;
  top: 100%;
  z-index: 1;
}
.ql-snow .ql-color-picker,
.ql-snow .ql-icon-picker {
  width: 28px;
}
.ql-snow .ql-color-picker .ql-picker-label,
.ql-snow .ql-icon-picker .ql-picker-label {
  padding: 2px 4px;
}
.ql-snow .ql-color-picker .ql-picker-label svg,
.ql-snow .ql-icon-picker .ql-picker-label svg {
  right: 4px;
}
.ql-snow .ql-icon-picker .ql-picker-options {
  padding: 4px 0px;
}
.ql-snow .ql-icon-picker .ql-picker-item {
  height: 24px;
  width: 24px;
  padding: 2px 4px;
}
.ql-snow .ql-color-picker .ql-picker-options {
  padding: 3px 5px;
  width: 152px;
}
.ql-snow .ql-color-picker .ql-picker-item {
  border: 1px solid transparent;
  float: left;
  height: 16px;
  margin: 2px;
  padding: 0px;
  width: 16px;
}
.ql-snow .ql-picker:not(.ql-color-picker):not(.ql-icon-picker) svg {
  position: absolute;
  margin-top: -9px;
  right: 0;
  top: 50%;
  width: 18px;
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-label]:not([data-label=''])::before,
.ql-snow .ql-picker.ql-font .ql-picker-label[data-label]:not([data-label=''])::before,
.ql-snow .ql-picker.ql-size .ql-picker-label[data-label]:not([data-label=''])::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-label]:not([data-label=''])::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-label]:not([data-label=''])::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-label]:not([data-label=''])::before {
  content: attr(data-label);
}
.ql-snow .ql-picker.ql-header {
  width: 98px;
}
.ql-snow .ql-picker.ql-header .ql-picker-label::before,
.ql-snow .ql-picker.ql-header .ql-picker-item::before {
  content: 'Normal';
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
  content: 'Heading 1';
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
  content: 'Heading 2';
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
  content: 'Heading 3';
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
  content: 'Heading 4';
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
  content: 'Heading 5';
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
  content: 'Heading 6';
}
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
  font-size: 2em;
}
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
  font-size: 1.5em;
}
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
  font-size: 1.17em;
}
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
  font-size: 1em;
}
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
  font-size: 0.83em;
}
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
  font-size: 0.67em;
}
.ql-snow .ql-picker.ql-font {
  width: 108px;
}
.ql-snow .ql-picker.ql-font .ql-picker-label::before,
.ql-snow .ql-picker.ql-font .ql-picker-item::before {
  content: 'Sans Serif';
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=serif]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {
  content: 'Serif';
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=monospace]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {
  content: 'Monospace';
}
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {
  font-family: Georgia, Times New Roman, serif;
}
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {
  font-family: Monaco, Courier New, monospace;
}
.ql-snow .ql-picker.ql-size {
  width: 98px;
}
.ql-snow .ql-picker.ql-size .ql-picker-label::before,
.ql-snow .ql-picker.ql-size .ql-picker-item::before {
  content: 'Normal';
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {
  content: 'Small';
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {
  content: 'Large';
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=huge]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {
  content: 'Huge';
}
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {
  font-size: 10px;
}
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {
  font-size: 18px;
}
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {
  font-size: 32px;
}
.ql-snow .ql-color-picker.ql-background .ql-picker-item {
  background-color: #fff;
}
.ql-snow .ql-color-picker.ql-color .ql-picker-item {
  background-color: #000;
}
.ql-toolbar.ql-snow {
  border: 1px solid #ccc;
  box-sizing: border-box;
  font-family: 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif;
  padding: 8px;
}
.ql-toolbar.ql-snow .ql-formats {
  margin-right: 15px;
}
.ql-toolbar.ql-snow .ql-picker-label {
  border: 1px solid transparent;
}
.ql-toolbar.ql-snow .ql-picker-options {
  border: 1px solid transparent;
  box-shadow: rgba(0,0,0,0.2) 0 2px 8px;
}
.ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-label {
  border-color: #ccc;
}
.ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-options {
  border-color: #ccc;
}
.ql-toolbar.ql-snow .ql-color-picker .ql-picker-item.ql-selected,
.ql-toolbar.ql-snow .ql-color-picker .ql-picker-item:hover {
  border-color: #000;
}
.ql-toolbar.ql-snow + .ql-container.ql-snow {
  border-top: 0px;
}
.ql-snow .ql-tooltip {
  background-color: #fff;
  border: 1px solid #ccc;
  box-shadow: 0px 0px 5px #ddd;
  color: #444;
  padding: 5px 12px;
  white-space: nowrap;
}
.ql-snow .ql-tooltip::before {
  content: "Visit URL:";
  line-height: 26px;
  margin-right: 8px;
}
.ql-snow .ql-tooltip input[type=text] {
  display: none;
  border: 1px solid #ccc;
  font-size: 13px;
  height: 26px;
  margin: 0px;
  padding: 3px 5px;
  width: 170px;
}
.ql-snow .ql-tooltip a.ql-preview {
  display: inline-block;
  max-width: 200px;
  overflow-x: hidden;
  text-overflow: ellipsis;
  vertical-align: top;
}
.ql-snow .ql-tooltip a.ql-action::after {
  border-right: 1px solid #ccc;
  content: 'Edit';
  margin-left: 16px;
  padding-right: 8px;
}
.ql-snow .ql-tooltip a.ql-remove::before {
  content: 'Remove';
  margin-left: 8px;
}
.ql-snow .ql-tooltip a {
  line-height: 26px;
}
.ql-snow .ql-tooltip.ql-editing a.ql-preview,
.ql-snow .ql-tooltip.ql-editing a.ql-remove {
  display: none;
}
.ql-snow .ql-tooltip.ql-editing input[type=text] {
  display: inline-block;
}
.ql-snow .ql-tooltip.ql-editing a.ql-action::after {
  border-right: 0px;
  content: 'Save';
  padding-right: 0px;
}
.ql-snow .ql-tooltip[data-mode=link]::before {
  content: "Enter link:";
}
.ql-snow .ql-tooltip[data-mode=formula]::before {
  content: "Enter formula:";
}
.ql-snow .ql-tooltip[data-mode=video]::before {
  content: "Enter video:";
}
.ql-snow a {
  color: #06c;
}
.ql-container.ql-snow {
  border: 1px solid #ccc;
}

.qlbt-operation-menu {
  z-index: 2000 !important;
}

/* Corrige listas no Quill 2 usando CSS legado do Quill 1 */
.ql-editor ol > li[data-list="bullet"]::before {
  content: '\2022' !important;
}

.ql-editor ol > li[data-list="ordered"]::before {
  content: counter(list-0, decimal) '. ' !important;
}

/* Opcional: checklists */
.ql-editor ol > li[data-list="checked"]::before {
  content: '\2611' !important;
}

.ql-editor ol > li[data-list="unchecked"]::before {
  content: '\2610' !important;
}
</style>